export default __webpack_public_path__ + "static/media/spira-logo.0f57f37c.svg";